import axios from "axios";
import { GENERAL_URL_API } from "../../components/Store";


/**
 * Este servicio devuelve un arreglo con los ids de libros favoritos de un cliente individual.
 * @param {{abortSignal:AbortSignal}} param0
 * @returns {Promise<string[]>} Una promesa que se resuelve en un arreglo de ids de libros favoritos.
 * @throws {Error} Si ocurre un error al obtener los favoritos.
 */

const getAll = async ({ abortSignal }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res([]);
	// 	}, 500);
	// });
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/listarFavoritos`,
			signal: abortSignal || null,
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		const responseData = response?.data?.favoritos;
		if (response.status === 200 && response.data.status === 1) {
			return Array.isArray(responseData) ? responseData : [];
		} else {
			return Promise.reject({ code: response?.data?.info || "Error getting favorites" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};


/**
 * Agrega un libro a los favoritos de un cliente individual.
 *
 * @async
 * @param {Object} options - Opciones para la solicitud de fetch.
 * @param {AbortSignal} options.abortSignal - Objeto AbortSignal para cancelar la solicitud.
 * @param {string} options.bookId - ID del libro a agregar a los favoritos.
 * @returns {Promise<boolean|Error>} Una promesa que se resuelve en `true` si el libro fue agregado exitosamente,
 * o se rechaza con un error si no pudo ser agregado.
 * @throws {Error} Si ocurre un error durante la solicitud de agregar el libro a favoritos.
 */

const add = async ({ abortSignal, bookId }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true);
	// 	}, 500);
	// });
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("accion", "Agregar");
		formData.append("idLibro", bookId);
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/gestionarFavoritos`,
			signal: abortSignal || null,
			headers: {
				"Content-Type": "multipart/form-data",
			},
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			return true;
		} else {
			return Promise.reject({ code: response?.data?.info || "Error adding favorite" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

/**
 * Elimina un libro de la lista de favoritos del usuario.
 * @param {{abortSignal:AbortSignal, bookId:String}} options - Opciones para la solicitud de eliminar el libro de favoritos.
 * @param {AbortSignal} options.abortSignal - Objeto AbortSignal para cancelar la solicitud.
 * @param {string} options.bookId - ID del libro a eliminar de los favoritos.
 * @returns {Promise<boolean|Error>} Una promesa que se resuelve en `true` si el libro fue eliminado exitosamente,
 * o se rechaza con un error si no pudo ser eliminado.
 * @throws {Error} Si ocurre un error durante la solicitud de eliminar el libro de favoritos.
 */
const remove = async ({ abortSignal, bookId }) => {
	// return new Promise((res, rej) => {
	// 	setTimeout(() => {
	// 		// rej({code:'Error, el correo ya existe'})
	// 		res(true);
	// 	}, 500);
	// });
	try {
		axios.defaults.baseURL = GENERAL_URL_API;
		axios.defaults.withCredentials = true;

		const formData = new FormData();
		formData.append("accion", "Remover");
		formData.append("idLibro", bookId);
		const response = await axios({
			method: "POST",
			url: `assets/clienteIndividual/gestionarFavoritos`,
			signal: abortSignal || null,
			headers: {
				"Content-Type": "multipart/form-data",
			},
			data: formData,
		});
		if (response.status === 200 && response.data.status === 1) {
			return true;
		} else {
			return Promise.reject({ code: response?.data?.info || "Error removing favorite" });
		}
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};

// Servicios de favoritos
export const FavoritesAPI = {
	getAll,
	add,
	remove,
};
